const venueList = document.querySelector('.venue-list');

if (venueList) {
  attachEvent('.venue-list .mod-filter .dropdown__list-item input', 'click', (ev) => {
    const parent = ev.target.closest('.venue-list');
    const checkedArray = getCheckedData(parent, 'locations');

    parent.querySelectorAll('.location-card').forEach((locationCard) => {
      const { locationCategory } = locationCard.dataset;
      locationCard.classList.toggle('is-hidden', !checkedArray.includes(locationCategory) && checkedArray.length > 0);
    });

    // Update URL with filter parameters
    const [baseUrl] = window.location.href.split('?');
    const urlParamsWithValue = checkedArray.length > 0 ? `locations=${checkedArray.join(',')}` : '';
    window.history.pushState({}, '', baseUrl + (urlParamsWithValue ? `?${urlParamsWithValue}` : ''));
  });
}
